import React from 'react'
import { Row } from 'antd'
import styles from './StaticsText.module.scss'
import { CustomCol, CustomTitle } from 'src/components'

interface StaticsTextProps { label: string, text: string }

const StaticsText: React.FC<StaticsTextProps> = ({ label, text }) => {
  return <Row>
    <CustomCol>
      <CustomTitle label={label} />
    </CustomCol>
    <CustomCol>
      <CustomTitle label={text} className={styles.textInfo} type={null} />
    </CustomCol>
  </Row>
}

export default StaticsText
